var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #662d89;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.11,
    y: 0.11,
    width: 99.78,
    height: 99.78,
    rx: 20,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.77,54.98c-.08-2.18-.08-4.66,0-6.84.1-2.77.34-8.24,2.11-10.4,2.27-2.77,7.03-2.65,10.4-2.81,7.87-.39,16.61-.42,24.46.1,6.59.44,9.73.7,10.62,8.02.66,5.41.69,12.96-.2,18.33-1.19,7.16-6.48,6.44-12.39,6.72-7.25.35-14.5.35-21.74,0-4.72-.22-10.93.36-12.39-5.32-.57-2.24-.79-5.49-.87-7.8ZM45.98,44.39v14.24l12.37-7.03-12.37-7.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeTheme);
export default __webpack_public_path__ + "static/media/youtube_theme.31d330cfa338fea4dffd47137e7cb15b.svg";
export { ForwardRef as ReactComponent };